import { Autocomplete, IconButton, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FIELD_CONSTRAINTS, FIELD_TYPES } from '../../../utility/constants'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { listDataService } from '../../../services/listDataService'
import DeleteIcon from '@mui/icons-material/Delete'

export const COMPARATIVE = ['lte', 'lt', 'gte', 'gt', 'eq']

const FieldConstraintItemEditUI = ({
  fields,
  constraintItem,
  updateConstraint = (updated) => {},
  onDelete,
  selectedField,
}) => {
  const { user } = useAuthContext()
  const [listItems, setListItems] = useState([])

  useEffect(() => {
    ;(async () => {
      if (
        selectedField?.data_structure == FIELD_TYPES.LIST ||
        selectedField?.data_structure == FIELD_TYPES.LIST_MULTI
      ) {
        const listItemsData = await listDataService.getData(user, selectedField?.list_id)
        setListItems(listItemsData.data)
      }
    })()
  }, [selectedField])

  const getSelectedField = (fieldId) => {
    const field = fields?.find((it) => it.id == fieldId)
    if (field) {
      return { value: field, label: field?.field_template_name }
    } else {
      return null
    }
  }

  const getSelectListItem = (itemId) => {
    const item = listItems?.find((it) => it.id == itemId)
    if (item) {
      return { value: item, label: item?.value }
    } else {
      return null
    }
  }

  return (
    <div style={{ display: 'flex', columnGap: 8, marginTop: 12, alignItems: 'center' }}>
      <Autocomplete
        value={
          constraintItem?.constraint
            ? { value: constraintItem?.constraint, label: constraintItem?.constraint }
            : null
        }
        id="autocomplete-operator"
        options={Object.entries(FIELD_CONSTRAINTS).map(([key, value]) => {
          return { value, label: key }
        })}
        sx={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Constraint" />}
        onChange={(e, v) => {
          updateConstraint({
            ...constraintItem,
            constraint: v?.value || null,
          })
        }}
        size="small"
      />

      <Autocomplete
        value={getSelectedField(constraintItem.related_field_template_id)}
        id="autocomplete-field"
        options={fields.map((it) => {
          return { value: it, label: it.field_template_name }
        })}
        sx={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Related Field Value (Optional)  " />}
        onChange={(e, v) => {
          updateConstraint({
            ...constraintItem,
            related_field_template_id: v?.value?.id || null,
            constant_value: null,
          })
        }}
        size="small"
        disabled={!COMPARATIVE.includes(constraintItem?.constraint)}
      />

      <Typography variant="p" style={{ fontSize: 12 }}>
        OR
      </Typography>

      {selectedField?.data_structure == FIELD_TYPES.LIST ? (
        <Autocomplete
          value={getSelectListItem(constraintItem.constant_value) || null}
          id="list-item-selection"
          options={listItems?.map((it) => {
            return { value: it, label: it.value }
          })}
          fullWidth
          renderInput={(params) => <TextField {...params} label="List Item" />}
          onChange={(e, v) => {
            updateConstraint({
              ...constraintItem,
              constant_value: v?.value?.id || null,
              related_field_template_id: null,
            })
          }}
          size="small"
          disabled={!COMPARATIVE.includes(constraintItem?.constraint)}
        />
      ) : (
        <TextField
          value={constraintItem.constant_value}
          id="outlined-basic"
          label="Value (Optional)"
          variant="outlined"
          onChange={(e) =>
            updateConstraint({
              ...constraintItem,
              constant_value: e.target.value || null,
              related_field_template_id: null,
            })
          }
          size="small"
          disabled={!COMPARATIVE.includes(constraintItem?.constraint)}
        />
      )}

      <IconButton onClick={() => onDelete(constraintItem.id)}>
        <DeleteIcon size="small" />
      </IconButton>
    </div>
  )
}

export default FieldConstraintItemEditUI
